export interface NavbarState {
  theme: 'light' | 'dark'
}


export const InitialNavbarState: NavbarState = {
  theme: 'dark'
}